import { CSSProperties } from 'react';
import 'styled-components';
import { Theme } from './theme';

declare module 'styled-components' {
    export interface DefaultTheme extends Theme {}
}

declare module '@material-ui/core/styles/createPalette' {
    interface Palette {
        contextBackgrounds: {
            error: CSSProperties['color'];
            info: CSSProperties['color'];
            neutral: CSSProperties['color'];
            primary: CSSProperties['color'];
            secondary: CSSProperties['color'];
            success: CSSProperties['color'];
            warning: CSSProperties['color'];
        };
        neutral: Palette['primary'];
    }

    interface PaletteOptions {
        contextBackgrounds?: {
            error: CSSProperties['color'];
            info: CSSProperties['color'];
            neutral: CSSProperties['color'];
            primary: CSSProperties['color'];
            secondary: CSSProperties['color'];
            success: CSSProperties['color'];
            warning: CSSProperties['color'];
        };
        neutral?: PaletteOptions['primary'];
    }
}
